import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DirectionsIcon from "@mui/icons-material/Directions";
import CropFreeIcon from "@mui/icons-material/CropFree";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ShareIcon from "@mui/icons-material/Share";
import * as colors from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { setActivePlace } from "../../store/map/reducer";
import { createSlice, nanoid } from "@reduxjs/toolkit";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { HOST_URL } from "../../shared/constants";
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import {
  setTravelMode,
  setStartLocation,
  addEndLocation,
  removeEndLocation,
  updateEndLocation,
  searchDirectionStart,
  setEndLocation,
} from "../../store/direction/reducer";
import { setLocationStart } from "../../store/direction/reducer";
import * as geometric from "geometric";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from 'react-i18next';
import CircularProgress from "@mui/material/CircularProgress";

export const SearchResult = (props) => {
  const [copiedField, setCopiedField] = useState(null);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [pickedLocation, setPickedLocation] = useState();
  const URL = useMemo(
    () =>
      `${HOST_URL}/open?lat=${pickedLocation?.[1]}&lng=${pickedLocation?.[0]}`,
    [pickedLocation]
  );
  const {
    places: placesResult,
    parcels: parcelsResult,
    roads: roadsResult,
    neighbourhoods: neighbourhoodsResult,
    nearBy_places: nearByResult,
    searchPlacesLoading: loading,
    currentLocation,
    serviceName,
  } = useSelector((state) => state.map);
  const [isOpen, setIsOpen] = useState(false);
  const { travelMode, startLocation, endLocation } = useSelector(
    (state) => state.direction
  );
  // console.log("kal",placesResult)
  const places = useMemo(
    () =>
      placesResult.map((place) => ({
        id: place.id,
        name: place.properties.name_eng + " - " + place.properties.legal_name,
        local_name: [place.properties.legal_na_2, place.properties.legal_na_3],
        city: [place.properties.city_name]

          .filter(Boolean)
          .join(" - "),

        name_navigation: place.properties.name_eng,

        region: place.properties.region,
        city: place.properties.city_name,
        zone: place.properties.zone_sub_c,
        woreda: place.properties.woreda,
        kebele: place.properties.kebele,
        image: place.properties.image,
        fun_type: place.properties.fun_type,

        parcel_id: place.properties.building_u,
        coordinates: place.geometry.coordinates,
        lat: place.properties.building_l,
        long: place.properties.building_1,
      })),
    [placesResult]
  );

  const parcels = useMemo(
    () =>
      parcelsResult
        .map((parcel) => ({
          id: parcel.id,
          name: parcel.properties?.prcl_uid,
          region: parcel.properties?.region,
          city: parcel.properties?.city_name,
          zone: parcel.properties?.zone_subci,
          woreda: parcel.properties?.woreda,
          kebele: parcel.properties?.kebele,
          coordinates: parcel.geometry
            ? geometric.polygonCentroid(parcel.geometry.coordinates[0][0])
            : undefined,
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1)),
    [parcelsResult]
  );

  const neighbourhoods = useMemo(
    () =>
      neighbourhoodsResult
        .map((neighbourhood) => ({
          id: neighbourhood.gid,
          name: neighbourhood.nh_code,

          coordinates: neighbourhood.geom
            ? geometric.polygonCentroid(neighbourhood.geom.coordinates[0][0])
            : undefined,
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1)),
    [parcelsResult]
  );

  const nearBy_places = useMemo(
    () =>
      nearByResult
        .map((road) => ({
          id: road.id,
          name: road.properties?.name_eng,
          coordinates: road.geometry?.coordinates,
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1)),
    [nearByResult]
  );

  const roads = useMemo(
    () =>
      roadsResult
        .map((road) => ({
          id: road.id,
          name: `Road ${road.properties?.road_uid}`,
          coordinates: road.geometry
            ? geometric.polygonCentroid(road.geometry.coordinates)
            : undefined,
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1)),
    [roadsResult]
  );

  const handleCopy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 1500);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };
  const data = useMemo(
    () => [
      ...places,
      ...neighbourhoods,
      ...parcels,
      ...roads,
      ...nearBy_places,
    ],
    [places, neighbourhoods, parcels, roads, nearBy_places]
  );
  // console.log("search data", data);
  return (
    <>
      <Box
        sx={{
          backgroundColor: colors.grey[100],
          borderRadius: 1,
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          boxShadow: 1,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            padding: "15px",
            backgroundColor: colors.common.white,
          }}
        >
          <Typography>{loading ? t('Searching') : t('resultsFound', { count: data.length })}</Typography>
        </Box>
        <Box
          sx={{
            padding: "10px",
            maxHeight: "50vh",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
              <CircularProgress />
            </Box>
          ) : data.length > 0 ? (
            data.map((place) => (
              <Box
                key={place.id}
                sx={{
                  padding: "10px",
                  backgroundColor: colors.common.white,
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                {place.image && (
                  <Box sx={{ mt: 2 }}>

                    <img
                      src={place.image}
                      alt={place.name}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "12px"
                      }}
                      onError={(e) => {
                        e.target.src = "/placeholder.png"; // optional fallback
                      }}
                    />
                    ,
                  </Box>
                )}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "18px",
                      color: "#000",
                      fontWeight: "bold"
                    }}
                    onClick={() => {
                      dispatch(
                        setActivePlace({
                          coordinate: place.coordinates,
                        })
                      );
                    }}
                  >
                    {place.name}

                  </Typography>
                </Box>

                {/* LOCAL NAME WITH LANGUAGE BADGE */}
                {place.local_name && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mt: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "17px",
                        fontWeight: 500,
                        color: "#5f6368",
                        fontStyle: "italic",
                        position: "relative",
                        "&::before": {
                          content: '""',
                          mr: 0.5,
                        }
                      }}
                    >
                      {place.local_name}
                    </Typography>

                  </Box>
                )}
                {/* INTERACTIVE ADDRESS SECTION */}
                {place.city && place.region && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: "#f8f9fa",
                      border: "1px solid #e0e0e0",
                      transition: "all 0.2s",
                      "&:hover": {
                        bgcolor: "#f1f3f4",
                        transform: "translateX(4px)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const addressText = `${place.region} Region, ${place.city} city}`;
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          color: "#3c4043",
                          fontWeight: 500,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {t('Location')}

                        {copiedField === 'address' && (
                            <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#34a853",
                              fontWeight: 600,
                              animation: "fadeInOut 1.5s",
                              "@keyframes fadeInOut": {
                                "0%, 100%": { opacity: 0 },
                                "50%": { opacity: 1 },
                              }
                            }}
                          >
                            {t('Copied')}
                          </Typography>
                        )}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#5f6368",
                          mt: 0.5,
                        }}
                      >
                        {place.region} {t('Region')}, {place.city} {t('City')}
                      </Typography>
                    </Box>

                    {place.fun_type && (
                      <Box
                        sx={{
                          fontSize: "12px",
                          px: 1.5,
                          py: 0.5,
                          borderRadius: "16px",
                          border: "2px solid #dadce0",
                          color: "#1a73e8",
                          backgroundColor: "#ffffff",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                          transition: "all 0.2s",
                          "&:hover": {
                            borderColor: "#1a73e8",
                            transform: "scale(1.05)",
                          }
                        }}
                      >
                        {place.fun_type}
                      </Box>
                    )}
                  </Box>
                )}
                {place.long && place.lat && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                      mt: 2.5,
                      p: 2,
                      borderRadius: 2,
                      bgcolor: "#f8f9fa",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#363637ff",
                      }}
                    >
                      {place.parcel_id && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon sx={{ fontSize: 20, color: "#ea4335" }} />
                          <span>{t('HouseNo')}: {place.parcel_id}</span>
                        </Box>
                      )}

                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 3,
                        mt: 1,
                      }}
                    >
                      {place.long != 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            p: 1,
                            borderRadius: 1,
                            bgcolor: "#ffffff",
                            border: "1px solid #dadce0",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            "&:hover": {
                              bgcolor: "#f1f3f4",
                              transform: "translateY(-1px)",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            }
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(place.long.toString(), 'long');
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#5f6368" }}>

                          </Typography>
                          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#363637ff" }}>
                            {place.long}
                          </Typography>
                          {copiedField === 'long' && (
                            <Typography sx={{ fontSize: "10px", color: "#34a853", ml: 1 }}>
                              ✓
                            </Typography>
                          )}
                        </Box>
                      )}
                      {place.lat != 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            p: 1,
                            borderRadius: 1,
                            bgcolor: "#ffffff",
                            border: "1px solid #dadce0",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            "&:hover": {
                              bgcolor: "#f1f3f4",
                              transform: "translateY(-1px)",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            }
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(place.lat.toString(), 'lat');
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#5f6368" }}>
                            {/* Lat: */}
                          </Typography>
                          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#363637ff" }}>
                            {place.lat}
                          </Typography>
                          {copiedField === 'lat' && (
                            <Typography sx={{ fontSize: "10px", color: "#34a853", ml: 1 }}>
                              ✓
                            </Typography>
                          )}
                        </Box>
                      )}

                    </Box>

                  </Box>
                )}

                {/* ENHANCED ACTION BUTTONS */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: 1,
                    mt: 3,
                    pt: 3,
                    borderTop: "2px solid #f0f0f0",
                    position: "relative",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {

                    [
                      {
                        icon: <DirectionsIcon sx={{ fontSize: 22 }} />,
                        label: "Directions",
                        description: "Get navigation",
                        count: place.direction_clicks,
                        color: "#1a73e8",
                        hoverColor: "#0d47a1",
                        onClick: async () => {
                          // Add click animation
                          const btn = document.getElementById(`dir-btn-${place.id}`);
                          if (btn) {
                            btn.style.transform = "scale(0.95)";
                            setTimeout(() => btn.style.transform = "", 150);
                          }

                          await props.setActiveTab("DIRECTION");
                          dispatch(
                            setEndLocation({
                              id: endLocation[0]?.id,
                              location: {
                                id: place.id,
                                label: place.name_navigation || place.name,

                                coordinates: place.coordinates,
                              },
                            })
                          );
                        }
                      },
                      {
                        icon: <ContentCopyIcon sx={{ fontSize: 22 }} />,
                        label: "Copy Name",
                        description: "Copy to clipboard",
                        count: place.saves,
                        color: "#1a73e8",
                        hoverColor: "#0d47a1",
                        onClick: (e) => {
                          const btn = document.getElementById(`copy-btn-${place.id}`);
                          if (btn) {
                            btn.style.transform = "scale(0.95)";
                            setTimeout(() => btn.style.transform = "", 150);
                          }
                          handleCopy(place.name, 'name');
                        }
                      },
                      {
                        icon: <ShareIcon sx={{ fontSize: 22 }} />,
                        label: "Share",
                        description: "Share location",
                        count: place.shares,
                        color: "#1a73e8",
                        hoverColor: "#0d47a1",
                        onClick: () => {
                          setPickedLocation(place.coordinates);
                          setIsOpen(true);
                          // Add share animation
                          const btn = document.getElementById(`share-btn-${place.id}`);
                          if (btn) {
                            btn.style.animation = "sharePulse 0.5s";
                            setTimeout(() => btn.style.animation = "", 500);
                          }
                        }
                      },
                      {
                        icon: <LocationOnIcon sx={{ fontSize: 22 }} />,
                        label: "Locate",
                        description: "Focus on map",
                        count: place.views,
                        color: "#1a73e8",
                        hoverColor: "#0d47a1",
                        onClick: () => {
                          // console.log("New result", place.coordinates);
                          dispatch(
                            setActivePlace({
                              coordinate: place.coordinates,
                              id: place.id,
                            })
                          );
                          // Add locate animation
                          const btn = document.getElementById(`locate-btn-${place.id}`);
                          if (btn) {
                            btn.style.animation = "locateSpin 0.5s";
                            setTimeout(() => btn.style.animation = "", 500);
                          }
                        }
                      }
                    ]
                      .map((action, idx) => (

                        <Tooltip
                          key={idx}
                          title={

                            <Box>
                              <Typography sx={{ fontWeight: 600 }}>{t(action.label)}</Typography>
                              <Typography sx={{ fontSize: "11px", opacity: 0.8 }}>{t(action.description)}</Typography>
                            </Box>
                          }
                          arrow
                          placement="top"
                        >
                          <Box sx={{ textAlign: "center" }}>
                            <IconButton
                              id={`${action.label.toLowerCase().replace(' ', '-')}-btn-${place.id}`}
                              size="large"
                              onClick={action.onClick}
                              sx={{
                                bgcolor: `${action.color}15`,
                                color: action.color,
                                width: 56,
                                height: 56,
                                mb: 1,
                                position: "relative",
                                overflow: "hidden",
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  background: `radial-gradient(circle at center, ${action.color}30, transparent)`,
                                  opacity: 0,
                                  transition: "opacity 0.3s",
                                },
                                "&:hover": {
                                  bgcolor: `${action.color}25`,
                                  transform: "translateY(-2px) scale(1.05)",
                                  boxShadow: `0 6px 20px ${action.color}40`,
                                  "&::before": {
                                    opacity: 1,
                                  },
                                },
                                "&:active": {
                                  transform: "translateY(0) scale(0.95)",
                                },
                                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                                "@keyframes sharePulse": {
                                  "0%": { transform: "scale(1)" },
                                  "50%": { transform: "scale(1.1)" },
                                  "100%": { transform: "scale(1)" },
                                },
                                "@keyframes locateSpin": {
                                  "0%": { transform: "rotate(0deg)" },
                                  "100%": { transform: "rotate(360deg)" },
                                },
                              }}
                            >
                              {action.icon}
                            </IconButton>

                                  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#5f6368", mb: 0.5 }}>
                                  {t(action.label)}
                                </Typography>

                            {action.count > 0 && (
                              <Box
                                sx={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  minWidth: 24,
                                  height: 20,
                                  px: 0.5,
                                  borderRadius: 10,
                                  bgcolor: `${action.color}20`,
                                  color: action.hoverColor,
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  border: `1px solid ${action.color}40`,
                                }}
                              >
                                {action.count.toLocaleString()}
                              </Box>
                            )}
                          </Box>
                        </Tooltip>

                      )
                      )
                  }
                </Box>
              </Box>
            ))
          ) : null}
        </Box>

      </Box>

      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <FacebookShareButton url={URL}>
              <FacebookIcon size={30} />
            </FacebookShareButton>
            <TwitterShareButton url={URL}>
              <TwitterIcon size={30} />
            </TwitterShareButton>
            <EmailShareButton url={URL}>
              <EmailIcon size={30} />
            </EmailShareButton>
            <LinkedinShareButton url={URL}>
              <LinkedinIcon size={30} />
            </LinkedinShareButton>
            <TelegramShareButton url={URL}>
              <TelegramIcon size={30} />
            </TelegramShareButton>
            <WhatsappShareButton url={URL}>
              <WhatsappIcon size={30} />
            </WhatsappShareButton>
              <CopyToClipboard
              text={URL}
              onCopy={() =>
                toast.info("Link copied to clipboard", {
                  position: "bottom-right",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  closeButton: false,
                })
              }
            >
              <Button
                startIcon={<FileCopyOutlinedIcon />}
                size="small"
                sx={{
                  backgroundColor: colors.blue[700],
                  color: colors.common.white,
                  textTransform: "none",
                  padding: "5px 15px",
                  "&:hover": {
                    backgroundColor: colors.blue[600],
                  },
                }}
              >
                {t('Copy')}
              </Button>
            </CopyToClipboard>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
